<span class="text-white badge badge-pill px-3" [ngClass]="getColor(rol)">
  {{getType(rol)}}
</span>
